// Shared filtering logic for content that should be excluded from search and grid displays

// Slugs that are redirected elsewhere and should not display in /blog grid or search
export const REDIRECTED_BLOG_SLUGS = new Set<string>([
  // From App router and Netlify redirects
  'talk-dirty-ai',
  'sexting-ai',
  'ai-sexting',
  'sex-chat-ai-sites',
  'sexting-ai-nsfw-websites',
  'nsfw-ai-chat-guide',
  'sex-chat-ai',
  'ai-sex-chat-guide',
  'free-ai-sex-chat',
  'sex-chatbot',
  'ai-sex-changing-everything',
  'ai-gf',
  'ai-girl-generator',
  'ai-girlfriend-chat',
  'best-ai-girlfriend-apps-websites-2026',
  'best-ai-girlfriend-apps-websites-2025',
  'uncensored-ai-image-generator',
  'ai-celebrity-porn',
  'ai-porn-chat',
  'ai-boyfriend',
  'ai-nude-girls',
  'nude-ai-generator',
  'roleplay-ai-chat-bot-free-no-sign-up',
  'roleplay-ai-chat-bot',
  'ai-girlfriend-online-free',
  'ai-girlfriend-stories',
  'dreamgf',
  'falling-in-love-ai-companion',
  'real-boyfriend-vs-ai-boyfriend',
  'romantic-ai',
  'technology-that-powers-ai-girlfriend-servers',
  'character-ai-alternative',
  'character-ai-nsfw-filter-bypass',
  'nsfw-character-ai-alternatives',
  'ai-hentai',
  'hentai-ai',
  'ai-hentai-chat',
  'ai-hentai-generator',
  'ai-generated-hentai',
  'breast-expansion-ehentai',
  'free-sex-ai',
  'soulgen-ai',
  'spicy-chat-ai-review',
  'spicychat-ai-app',
  'gptgirlfriend-review',
  'ai-sexting-apps-2026',
  'sex-chat-bot',
]);

// Filter function for blog posts
export const filterValidBlogPosts = (posts: any[]) => {
  return posts.filter((post: any) => {
    // Exclude posts with redirected slugs
    if (post?.slug && REDIRECTED_BLOG_SLUGS.has(post.slug)) {
      return false;
    }
    
    // Exclude posts that export undefined (like ai-celebrity-porn.ts)
    if (!post || post === undefined) {
      return false;
    }
    
    // Ensure post has required fields
    return post.title && post.slug && post.excerpt;
  });
};

// Filter function for besticles (currently no filtering needed, but keeping for consistency)
export const filterValidBesticles = (posts: any[]) => {
  return posts.filter((post: any) => {
    // Exclude posts that export undefined
    if (!post || post === undefined) {
      return false;
    }
    
    // Ensure post has required fields
    return post.title && post.slug && post.excerpt;
  });
};

// Filter function for reviews (currently no filtering needed, but keeping for consistency)
export const filterValidReviews = (posts: any[]) => {
  return posts.filter((post: any) => {
    // Exclude posts that export undefined
    if (!post || post === undefined) {
      return false;
    }
    
    // Ensure post has required fields
    return post.title && post.slug && post.excerpt;
  });
};
